import axios from "axios";
import {
   FETCH_PRODUCT_SUCCESS,
   FETCH_PRODUCT_FAILURE
} from "../actionTypes";

const Base_Url = process.env.REACT_APP_BASE_URL;

export const fetchProducts = (page = 1, limit = 10, searchTerm = "",displaySection="") => {
  return async (dispatch) => {
    try {
      const token=localStorage.getItem("token");
      const res = await axios.get(`${Base_Url}/api/product/getProductList`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
        params: { page, limit, search: searchTerm, displaySection},
      });
      
      const availableProducts = Array.isArray(res.data.data)
        ? res.data.data.filter((product) => !product.isBlock) 
        : [];
      dispatch({
        type: FETCH_PRODUCT_SUCCESS,
        payload: {
          product: availableProducts,
          message: res.data.message || "Product fetched successfully",
          totalPages: res.data.totalPages,
          totalRecords: res.data.totalRecords,
          currentPage: res.data.currentPage,
        },
      });
    } catch (err) {
      dispatch({
        type: FETCH_PRODUCT_FAILURE,
        payload: err.response?.data?.message || err.message,
      });
    }
  };
};
